import React, { forwardRef } from "react";
import { MenuItemAction, MenuItemLink } from "@prestosports/commons-ui";
import Box from "@material-ui/core/Box";

// eslint-disable-next-line no-unused-vars
const MenuActions = forwardRef(({ actions, menuItem }, ref) => {
	return actions.map((a, index) => (
		<Box key={a.description}>
			{a.to && (
				<MenuItemLink
					label={a.description}
					icon={a.icon}
					iconAvatar={a.iconAvatar}
					to={a.to}
					id={`menu-item-${index}`}
				/>
			)}
			{a.action && (
				<MenuItemAction
					label={a.description}
					icon={a.icon}
					iconAvatar={a.iconAvatar}
					onClick={() => a.action(menuItem)}
					id={`menu-item-${index}`}
				/>
			)}
		</Box>
	));
});

export default MenuActions;
